import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <>
      <Helmet><title>404 — Page Not Found | ITClave India</title></Helmet>
      <section style={{ background:'var(--bg)', minHeight:'70vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'80px 0', textAlign:'center' }}>
        <div className="container">
          <div style={{ fontSize:'6rem', marginBottom:16, lineHeight:1 }}>🔍</div>
          <h1 style={{ fontFamily:"'Outfit',sans-serif", fontSize:'clamp(2rem,5vw,4rem)', fontWeight:900, letterSpacing:'-.04em', marginBottom:12 }}>
            <span className="gt">404</span> — Page Not Found
          </h1>
          <p style={{ color:'var(--text2)', fontSize:'1.05rem', maxWidth:480, margin:'0 auto 32px', lineHeight:1.75 }}>
            Oops! The page you're looking for doesn't exist. It may have been moved or the URL is incorrect.
          </p>
          <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/" className="btn-main">🏠 Go Home</Link>
            <Link to="/contact" className="btn-out">📞 Contact Us</Link>
          </div>
        </div>
      </section>
    </>
  );
}
